import { SALON } from "@/data/content";

export default function Impressum() {
  return (
    <div data-testid="page-impressum">
      <section className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Rechtliches</span>
          <h1 className="text-[clamp(32px,4vw,56px)] leading-tight mb-10">Impressum</h1>

          <div className="space-y-8 text-sm text-[#24211D]/80 leading-relaxed">
            <div>
              <h2 className="text-xl mb-3 text-[#24211D]">Angaben gemäß § 5 TMG</h2>
              <p>
                {SALON.name}<br />
                Inhaberin: Nezahat Ulupinar<br />
                {SALON.street}<br />
                {SALON.city}
              </p>
            </div>
            <div>
              <h2 className="text-xl mb-3 text-[#24211D]">Kontakt</h2>
              <p>
                Telefon: {SALON.phoneDisplay}<br />
                E-Mail: nezahatozan62@gmail.com
              </p>
            </div>
            <div>
              <h2 className="text-xl mb-3 text-[#24211D]">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>Nezahat Ulupinar, Anschrift wie oben</p>
            </div>
            <div>
              <h2 className="text-xl mb-3 text-[#24211D]">Haftung für Inhalte</h2>
              <p className="text-xs font-sans">
                Die Inhalte dieser Seiten wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine Gewähr übernehmen.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
